<template>
  <div class="com-bg">
    <div class="com-bg-img" :style="{ height: screenHeight + 'px' }"></div>
  </div>
</template>

<script>
export default {
  name: "com-bg",
  components: {},
  data() {
    return {
      screenHeight: 0, // 屏幕高度
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    this.screenHeight = document.documentElement.clientHeight; //屏幕高度
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang='scss' scoped>
.com-bg {
  .com-bg-img {
    width: 100%;
    background: rgba(0, 0, 0, 1) url("~@/images/home/h_bg_top.png") no-repeat
      center center;
    background-size: 100% 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/com-bg.vue